import api from "../axios";
import { invalidateDisciplinesCache } from "./disciplines";

/**
 * Create a new category
 * @param {Object} categoryData - Category data (name, code, description, discipline_id)
 */
export const createCategory = async (categoryData) => {
  const { discipline_id, ...categoryFields } = categoryData;
  const response = await api.post("/categories", {
    category: categoryFields,
    discipline_id: discipline_id
  });
  invalidateDisciplinesCache();
  return response.data;
};

/**
 * Update a category
 * @param {number} categoryId - Category ID
 * @param {Object} categoryData - Category data
 */
export const updateCategory = async (categoryId, categoryData) => {
  const response = await api.patch(`/categories/${categoryId}`, {
    category: categoryData
  });
  invalidateDisciplinesCache();
  return response.data;
};

/**
 * Delete a category
 * @param {number} categoryId - Category ID
 */
export const deleteCategory = async (categoryId) => {
  const response = await api.delete(`/categories/${categoryId}`);
  invalidateDisciplinesCache();
  return response.data;
};

